<template>
  <mdb-modal :show="showModal" size="lg">
    <mdb-modal-header>
      <strong>Link with Taskqueue</strong>
    </mdb-modal-header>
    <mdb-modal-body>
      <div v-if="projects">
        <div class="w-100 mt-3">
          <h3>Link with taskqueue:</h3>
          <div>
            <input
              type="text"
              v-model="linkTaskqueueProjectSearch"
              @input="filterLinkTaskqueueProjects"
              placeholder="Search projects"
              class="form-control mb-2"
              @focus="showLinkTaskqueueProjectDropdown = true"
            />
            <div
              v-if="showLinkTaskqueueProjectDropdown && filteredLinkTaskqueueProjects.length > 0"
              class="dropdown-menu show"
            >
              <a
                class="dropdown-item"
                v-for="(projectItem, index) in filteredLinkTaskqueueProjects"
                :key="index"
                @click="selectLinkTaskqueueProject(projectItem)"
              >
                {{ projectItem.name }} - {{ projectItem.client.email }}
              </a>
            </div>
          </div>
          <mdb-input
            v-if="selectedLinkTaskqueueProjectId"
            label="Search taskqueue"
            v-model="taskqueueLinkSearch"
            @change="searchTaskqueueOver(null)"
          />
          <mdb-tbl v-if="selectedLinkTaskqueueProjectId" class="w-100" hover>
            <mdb-tbl-head>
              <tr>
                <th>ID</th>
                <th>Taskqueue Name</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr
                v-for="taskqueue in taskqueueSearchResults"
                :key="taskqueue.taskqueueid"
                :class="`${taskqueue.checked ? 'bg-success' : ''}`"
                @click="selectLinkTaskqueueResult(taskqueue.taskqueueid)"
              >
                <td>{{ taskqueue.taskqueueid }}</td>
                <td>{{ taskqueue.queuename }}</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </div>
        <div v-if="selectedLinkTaskqueueId">
          <label for="linkTaskqueueTask">Use task</label>
          <select
            id="linkTaskqueueTask"
            name="linkTaskqueueTask"
            v-model="linkTaskqueueTask"
            class="browser-default custom-select"
          >
            <option value="">Last one (default)</option>
            <option v-for="task in linkTaskqueueTasks" :key="task.taskid" :value="task.taskid">
              {{ task.name }}
            </option>
          </select>
        </div>
      </div>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn color="secondary" @click="showModal = false">Close</mdb-btn>
      <mdb-btn color="primary" @click="postLinkWithTaskqueue">Save changes</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import Apicall from '@/libs/Apicall';
import {
  mdbInput,
  mdbModal,
  mdbModalHeader,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn,
  mdbTbl,
  mdbTblBody,
  mdbTblHead,
} from 'mdbvue';

export default {
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    mdbInput,
  },
  props: {
    value: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      linkTaskqueueProjectSearch: '',
      showLinkTaskqueueProjectDropdown: false,
      filteredLinkTaskqueueProjects: [],
      taskqueueLinkSearch: '',
      projectSearch: '',
      taskqueueSearchResults: [],
      linkTaskqueueTask: null,
      linkTaskqueueTasks: [],
      selectedLinkTaskqueueProjectId: null,
      duplicateLinkTaskqueueProjectId: null,
      taskqueues: [],
      showModal: false,
      projects: null,
      timeoutId: undefined,
    };
  },
  computed: {
     selectedLinkTaskqueueId() {
        const selectedLinkedTaskqueues = this.taskqueueSearchResults.filter((result) => result.checked);

        return selectedLinkedTaskqueues.length > 0 ? selectedLinkedTaskqueues.shift()?.taskqueueid : null;
      },
  },
  watch: {
    value(newVal) {
      console.log('Taskqueue', newVal);
      if (newVal) {
        this.showModal = true;
        this.getProjects();
      } else {
        this.showModal = null;
        this.value = null;
        this.projects = null;
        this.linkTaskqueueTasks = [];
        this.linkTaskqueueTask = null;
        this.taskqueueSearchResults = [];
      }
    },
    selectedLinkTaskqueueProjectId(newVal) {
      if (!newVal) {
        return;
      }

      this.searchTaskqueueOver();
    },
    selectedLinkTaskqueueId(currentTaskqueueId) {
      if (currentTaskqueueId) {
        this.getTasksForLinkTaskqueue();
      } else {
        this.linkTaskqueueTask = '';
      }
    },
    showModal(newVal) {
      if (!newVal) {
        this.projects = null;
        this.linkTaskqueueTasks = [];
        this.linkTaskqueueTask = null;
        this.taskqueueSearchResults = [];
      }
    },
  },
  methods: {
    filterProjects() {
      const searchTerm = this.projectSearch.toLowerCase();
      this.filteredProjects = this.projects.filter((project) => project.name.toLowerCase().includes(searchTerm)
            || project.client?.email?.toLowerCase().includes(searchTerm));
    },
    getProjects() {
      const api = new Apicall();

      api.call('GET', 'api/project/get-all', null).then((response) => {
        if (response.status === 'OK') {
          if (
            typeof response.data.projectinfos === 'object'
            && !Array.isArray(response.data.projectinfos)
          ) {
            this.projects = Object.values(response.data.projectinfos);
          } else {
            this.projects = response.data.projectinfos || [];
          }
          this.filterProjects();
        } else {
          this.error = response.msg;
        }
      });
    },
    selectLinkTaskqueueResult(taskqueueid) {
      this.taskqueueSearchResults = this.taskqueueSearchResults.map((taskqueue) => ({ ...taskqueue, checked: taskqueueid === taskqueue.taskqueueid }));
    },
    filterLinkTaskqueueProjects() {
      this.filteredLinkTaskqueueProjects = this.projects.filter((project) => project.name.toLowerCase().includes(this.linkTaskqueueProjectSearch.toLowerCase()));
    },
    selectLinkTaskqueueProject(project) {
      this.selectedLinkTaskqueueProjectId = project.projectid;
      this.linkTaskqueueProjectSearch = project.name;
      this.showLinkTaskqueueProjectDropdown = false;
    },
    searchTaskqueue() {
        this.taskqueueSearchResults = this.taskqueues.filter((taskqueue) => taskqueue.queuename.toLowerCase().includes(this.taskqueueLinkSearch.toLowerCase() && Number.parseInt(taskqueue.tasqueueid, 10) !== this.value.taskqueueid));
    },
    getTasksForLinkTaskqueue() {
      const taskqueueId = this.taskqueueSearchResults.filter((taskqueue) => taskqueue.checked).shift()?.taskqueueid;
      if (!taskqueueId) {
        return;
      }
      const apiCall = new Apicall();

      apiCall
        .call('GET', `api/task/tasks-in-order?taskId=${taskqueueId}`, null)
        .then((response) => {
          if (response.status === 'OK') {
            this.linkTaskqueueTasks = response.data.tasks.filter((task) => !task.isspotcheck);
          } else {
            this.notificationError(response.msg ?? 'Unknown error');
          }
        });
    },
    postLinkWithTaskqueue() {
      const api = new Apicall();

      api.call('POST', 'api/task/link-with-taskqueue', {
        taskqueue_id: this.value.taskqueueid,
        link_task_id: this.linkTaskqueueTask,
        linked_taskqueue_id: this.selectedLinkTaskqueueId,
      }).then((response) => {
        if (response.status === 'OK') {
          this.notificationSusscess(`Linked with taskqueue #${this.value.taskqueueid} successfully`);
          this.$emit('taskqueueLinkUpdated', this.value);
          this.value = null;
        } else {
          this.notificationError(response.msg ?? 'Unknown error');
        }
      });
    },
    notificationError(_messsage) {
        this.$notify.error({ message: _messsage, position: 'top right', timeOut: 5000 });
    },
    notificationSusscess(_messsage) {
        this.$notify.success({ message: _messsage, position: 'top right', timeOut: 5000 });
    },
    searchTaskqueueOver(overridedSearch = null) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        const apiCall = new Apicall();

        apiCall.call('POST', 'api/task/search-taskqueue-within-project', {
          projectId: this.selectedLinkTaskqueueProjectId,
          searchTerm: overridedSearch ?? this.taskqueueLinkSearch,
        }).then((response) => {
          if (response.status === 'OK') {
            this.taskqueueSearchResults = [...response.data].filter((tq) => tq.taskqueueid !== this.value.taskqueueid);
          } else {
            this.notificationError(response.msg ?? 'Unknown error');
          }
        });
      }, 1000);
    },
  },
};
</script>

<style scoped>
/* Add any custom styles here */
</style>
